import { forwardRef } from 'react'
import Tooltip from 'components/Tooltip'
import * as Styled from './styled'

interface IAvatarActionButtonProps {
  icon: React.ReactElement
  tooltipText: string
  // Suppress the tooltip while this button's flyout is open (mirrors the
  // VolumeControlButton pattern) so the panel and tooltip never overlap.
  isActive?: boolean
  onClick: () => void
  testId?: string
}

const AvatarActionButton = forwardRef<
  HTMLButtonElement,
  IAvatarActionButtonProps
>(({ icon, tooltipText, isActive, onClick, testId }, ref) => (
  <Tooltip tooltipText={isActive ? '' : tooltipText} ref={ref}>
    <Styled.ActionButton
      type="button"
      onClick={onClick}
      $isActive={isActive}
      data-testid={testId}
    >
      {icon}
    </Styled.ActionButton>
  </Tooltip>
))

AvatarActionButton.displayName = 'AvatarActionButton'

export default AvatarActionButton
